import { h } from './core-6f498fd9.js';
import { C as CsmOverlayType, a as CsmOverlayScrollStrategy, c as csmOverlayBlockScrollId } from './csm-overlay.constants-8ff0efb3.js';
var CsmOverlay = /** @class */ (function () {
    function CsmOverlay() {
        /**
         * Whether the overlay should be shown or not. It will also set scroll listeners when needed.
         */
        this.active = false;
        /**
         * Set the type of background.
         */
        this.type = CsmOverlayType.Light;
        /**
         * There are 3 scroll strategies (e.g. what happens when the user scrolls on the overlay) available:<br/>
         * - None: no special handling, let the scroll be handled normally (generally meaning that the body will scroll):<br/>
         * - Close: automatically close the overlay.<br/>
         *   *Important note:* If the overlay's content has a scrollable content,
         *   you might have to manually handle a blocking behaviour for this content. Fortunately it's simple: just add
         *   `overscroll-behavior: none` on the scrolling container inside the overlay to disable the "bubbling" of the scroll.<br/>
         * - Block: block the scroll on the `body` element.
         */
        this.scrollStrategy = CsmOverlayScrollStrategy.None;
        /**
         * Sets whether the overlay should close on ESC keyboard press
         */
        this.dismissOnEscape = false;
        this.handleScroll = this.handleScroll.bind(this);
        this.addScrollBlockerStyle();
    }
    CsmOverlay.prototype.componentDidLoad = function () {
        this.setScrollBlocker();
    };
    CsmOverlay.prototype.componentDidUnload = function () {
        this.removeScrollListener();
        this.removeScrollBlocker();
    };
    CsmOverlay.prototype.toggleScrollBehavior = function () {
        if (this.active) {
            this.setScrollListener();
            this.setScrollBlocker();
        }
        else {
            this.removeScrollListener();
            this.removeScrollBlocker();
            this.csmDismiss.emit();
            this.csmOverlayClose.emit();
        }
    };
    CsmOverlay.prototype.handleKeyDown = function (event) {
        if (this.dismissOnEscape && event.key === 'Escape') {
            this.active = false;
        }
    };
    CsmOverlay.prototype.setScrollBlocker = function () {
        if (this.scrollStrategy === CsmOverlayScrollStrategy.Block && this.active) {
            document.body.classList.add(csmOverlayBlockScrollId);
        }
    };
    CsmOverlay.prototype.handleScroll = function () {
        switch (this.scrollStrategy) {
            case CsmOverlayScrollStrategy.Close:
                this.active = false;
                return;
            default:
                return;
        }
    };
    CsmOverlay.prototype.setScrollListener = function () {
        document.addEventListener('scroll', this.handleScroll, { passive: true });
    };
    CsmOverlay.prototype.removeScrollListener = function () {
        document.removeEventListener('scroll', this.handleScroll);
    };
    CsmOverlay.prototype.removeScrollBlocker = function () {
        document.body.classList.remove(csmOverlayBlockScrollId);
    };
    CsmOverlay.prototype.addScrollBlockerStyle = function () {
        if (!document.head.querySelector("[" + csmOverlayBlockScrollId + "]")) {
            var style = document.createElement('style');
            style.innerText = "." + csmOverlayBlockScrollId + " { overflow: hidden; }";
            style.setAttribute(csmOverlayBlockScrollId, '');
            document.head.appendChild(style);
        }
    };
    CsmOverlay.prototype.render = function () {
        return h("slot", null);
    };
    Object.defineProperty(CsmOverlay, "is", {
        get: function () { return "csm-overlay"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmOverlay, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmOverlay, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-overlay.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmOverlay, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-overlay.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmOverlay, "properties", {
        get: function () {
            return {
                "active": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Whether the overlay should be shown or not. It will also set scroll listeners when needed."
                    },
                    "attribute": "active",
                    "reflect": true,
                    "defaultValue": "false"
                },
                "type": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "CsmOverlayType",
                        "resolved": "CsmOverlayType.Dark | CsmOverlayType.DarkStrong | CsmOverlayType.Light | CsmOverlayType.LightStrong",
                        "references": {
                            "CsmOverlayType": {
                                "location": "import",
                                "path": "./csm-overlay.constants"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Set the type of background."
                    },
                    "attribute": "type",
                    "reflect": true,
                    "defaultValue": "CsmOverlayType.Light"
                },
                "scrollStrategy": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "CsmOverlayScrollStrategy",
                        "resolved": "CsmOverlayScrollStrategy.Block | CsmOverlayScrollStrategy.Close | CsmOverlayScrollStrategy.None",
                        "references": {
                            "CsmOverlayScrollStrategy": {
                                "location": "import",
                                "path": "./csm-overlay.constants"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "There are 3 scroll strategies (e.g. what happens when the user scrolls on the overlay) available:<br/>\n- None: no special handling, let the scroll be handled normally (generally meaning that the body will scroll):<br/>\n- Close: automatically close the overlay.<br/>\n   *Important note:* If the overlay's content has a scrollable content,\n   you might have to manually handle a blocking behaviour for this content. Fortunately it's simple: just add\n   `overscroll-behavior: none` on the scrolling container inside the overlay to disable the \"bubbling\" of the scroll.<br/>\n- Block: block the scroll on the `body` element."
                    },
                    "attribute": "scroll-strategy",
                    "reflect": false,
                    "defaultValue": "CsmOverlayScrollStrategy.None"
                },
                "dismissOnEscape": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Sets whether the overlay should close on ESC keyboard press"
                    },
                    "attribute": "dismiss-on-escape",
                    "reflect": false,
                    "defaultValue": "false"
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmOverlay, "events", {
        get: function () {
            return [{
                    "method": "csmDismiss",
                    "name": "csmDismiss",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [{
                                "text": "Deprecated in favor of csmClose <br />\nSent when `active` is set to false",
                                "name": "deprecated"
                            }],
                        "text": ""
                    },
                    "complexType": {
                        "original": "any",
                        "resolved": "any",
                        "references": {}
                    }
                }, {
                    "method": "csmOverlayClose",
                    "name": "csmOverlayClose",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": "Sent when `active` is set to false"
                    },
                    "complexType": {
                        "original": "any",
                        "resolved": "any",
                        "references": {}
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmOverlay, "watchers", {
        get: function () {
            return [{
                    "propName": "active",
                    "methodName": "toggleScrollBehavior"
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmOverlay, "listeners", {
        get: function () {
            return [{
                    "name": "keydown",
                    "method": "handleKeyDown",
                    "target": "document",
                    "capture": false,
                    "passive": false
                }];
        },
        enumerable: true,
        configurable: true
    });
    return CsmOverlay;
}());
export { CsmOverlay as C };
